/* t-s-i.de Webshop-Angebot (TSI 3.8): Dialog-Logik. jsPDF 2.5.2, qrcode-generator 1.4.4 (jsDelivr) und das PDF-Layout (assets/tsi-quote-pdf.js) werden erst beim Oeffnen des Dialogs geladen. */
/* TSI Angebot aus Warenkorb: Dialog, Warenkorbdaten, PDF-Download, Lead an info@ (seit 3.8) */
/* Seit 3.8.1: Lagerstatus je Position (mengenbezogen) aus sections/fetch-quote-stock.liquid, Logik in snippets/tsi-line-stock.liquid.
   Der Status wird im Link-Payload mitgespeichert, damit ein neu erzeugtes PDF den Stand zum Angebotszeitpunkt zeigt.
   Seit 3.8.2: Link auf die Produktseite in der Angebotssprache je Position (it.url, im Link-Payload an Index 10).
   Seit 3.8.2: Erst uebermitteln, dann PDF. Das Kontaktformular wird per fetch (gleiche Domain) abgeschickt und Shopifys
   Antwort ausgewertet: contact_posted=true = angenommen, dann entsteht das PDF. /challenge = Shopify verlangt eine
   sichtbare Captcha-Pruefung: Angebot wird im Browser zwischengespeichert (localStorage tsi-quote-pending), der Dialog
   zeigt die Ansicht "Sicherheitspruefung", nach der Rueckkehr (?contact_posted=true) entsteht das PDF automatisch.
   Abgelehnt oder unklar = kein PDF, Hinweis im Formular. Damit liegt jedes PDF, das ein Kunde hat, auch in info@.
   Anlagen sind nur auf Anfrage (eigene Shopify-Forms-Formulare) und nie im Warenkorb, deshalb gibt es hier nur den PDF-Weg.
   Rabatt auf Bestellung (z. B. automatische Rabatte -20 % / -25 %): Prozentsatz aus cart_level_discount_applications,
   ersatzweise berechnet, im PDF neben "Rabatt" ausgewiesen (Payload-Feld xp).
   Rechnungsadresse, optionale USt-IdNr. und abweichende Lieferadresse (Payload c[4] bis c[6]); Vorbelegung fuer eingeloggte
   Kunden aus cfg.customer (Kundenkonto bzw. B2B-Standort), sonst aus der letzten Eingabe (localStorage tsi-quote-contact).
   USt-IdNr. nur fuer Rechnungslaender in der EU ausser DE (dann Pflicht). Versandoptionen fuer die Lieferadresse ueber
   /cart/prepare_shipping_rates.json + async_shipping_rates.json (dieselben Raten wie im Checkout), im PDF unter der Summe
   (Payload-Feld sr). Die guenstigste Rate ist im Gesamtpreis enthalten, teurere stehen nur als Alternative darunter.
   Die Versandkosten gelten fuer beide Bestellwege (online und per E-Mail). Liefert Shopify keine Raten, steht nur
   der Hinweis "zzgl. Versandkosten" (ohne Tarif- oder Gebuehrenhinweis).
   Hinweis Lagerstatus/Lieferzeiten: Stand bei Angebotserstellung, Zwischenverkauf vorbehalten (in ship_note/ship_note_rates).
   Bestelllink mit Vorbelegung (orderLinkFull): Textlink im PDF, Checkout-Button im Dialog und Lead-Mail uebergeben
   E-Mail und Lieferadresse per checkout[...]-Parametern an den Checkout. Der QR-Code bleibt beim kurzen Link.
   Seit 3.8.4: (1) Beim Absenden wechselt der Dialog vom modalen in den nicht-modalen Modus (eigener Hintergrund,
   z-index 9990), weil ein modaler Dialog in der obersten Browser-Ebene liegt und Shopifys Captcha-Raetsel sonst
   dahinter erscheint. (2) Im Formular schliesst ein Klick neben das Fenster den Dialog nicht mehr (nur X, Abbrechen,
   Escape); in den anderen Ansichten nur, wenn Maus-Druecken und Loslassen beide auf dem Hintergrund liegen.
   Seit 3.8.5: Versandraten mit vollstaendiger Adresse (Strasse, Zusatz, Firma, Name). Nur mit PLZ/Ort rechnet UPS
   einen Zuschlag (gemessen 28.09.2026: 14,13 statt 12,52 EUR Standard), dann weicht das Angebot vom Checkout ab.
   Bestelllink uebergibt zusaetzlich die Firma (im Checkout Pflichtfeld).
   Zahlungshinweis: 30 Tage netto, Vorkasse allgemein vorbehalten (nicht nur fuer Neukunden, Kevin 28.09.2026).
   Seit 3.15: Wartungseinsatz laut Wartungsvertrag (nur fuer angemeldete t-s-i.de-Mitarbeiter, Checkbox tsi_wv aus
   tsi-quote-pdf.js): 15 % auf alle Positionen direkt in den Angebotsdaten, Vertriebsmitarbeiter Maximilian Schwartz,
   kein Online-Bestelllink (Anlage SN nur, falls uebergeben). Im Link-Payload gespeichert (w, Listenpreis an Index 11), damit
   "PDF erneut erzeugen" aus der Lead-Mail dasselbe PDF liefert. */
(function () {
  if (window.tsiQuoteReady) return;
  window.tsiQuoteReady = true;

  var cfgEl = document.getElementById('tsi-quote-config');
  var dlg = document.getElementById('tsi-quote-dialog');
  if (!cfgEl || !dlg) return;
  var cfg = JSON.parse(cfgEl.textContent);

  var TX = {
    de: {
      title_pdf: 'Angebot als PDF',
      lead_pdf: 'Wir erstellen Ihnen ein PDF-Angebot mit allen Artikeln und Preisen aus Ihrem Warenkorb.',
      submit_pdf: 'PDF-Angebot erstellen', busy_pdf: 'PDF wird erstellt\u2026',
      done_pdf_title: 'Ihr Angebot ist fertig', done_pdf_text: 'Das PDF wurde heruntergeladen. Bestellen k\u00f6nnen Sie direkt hier oder sp\u00e4ter jederzeit \u00fcber den Link im PDF.',
      again: 'PDF erneut herunterladen',
      err_empty: 'Ihr Warenkorb ist leer.',
      err_pdf: 'Das PDF-Angebot konnte gerade nicht erstellt werden. Bitte versuchen Sie es in einigen Minuten erneut oder schreiben Sie uns an {email}.',
      verify_title: 'Fast geschafft',
      verify_pdf: 'Bitte best\u00e4tigen Sie auf der n\u00e4chsten Seite, dass Sie kein Roboter sind. Anschlie\u00dfend wird Ihr PDF-Angebot automatisch heruntergeladen.',
      verify_btn: 'Weiter',
      pdf: {
        title: 'Angebot', number: 'Angebotsnummer', date: 'Datum', valid: 'Gültig bis', reference: 'Ihre Referenz',
        col_pos: 'Pos.', col_item: 'Artikel', col_qty: 'Menge', col_unit: 'Einzelpreis', col_total: 'Gesamt', sku: 'Art.-Nr.',
        product_link: 'Zur Produktseite',
        discount_note: 'inkl. Staffelrabatt', subtotal: 'Summe Positionen', cart_discount: 'Rabatt', total: 'Gesamtsumme netto',
        vat: 'USt-IdNr.', ship_to: 'Lieferadresse', same_address: 'wie Rechnungsadresse',
        ship_row: 'Versand {name}', ship_alt: 'Alternativ: {name}',
        ship_note_rates: 'Lagerstatus und Lieferzeiten entsprechen dem Stand bei Angebotserstellung, Zwischenverkauf vorbehalten.\nBestellung per E-Mail: Zahlung 30 Tage netto, Vorkasse vorbehalten.',
        net_note: 'Alle Preise netto zzgl. gesetzlicher USt. Lieferungen an Unternehmen in anderen EU-Staaten mit gültiger USt-IdNr. und Lieferungen in Drittländer sind umsatzsteuerfrei.',
        ship_note: 'Zzgl. Versandkosten.\nLagerstatus und Lieferzeiten entsprechen dem Stand bei Angebotserstellung, Zwischenverkauf vorbehalten.\nBestellung per E-Mail: Zahlung 30 Tage netto, Vorkasse vorbehalten.',
        order_title: 'So bestellen Sie',
        order_online_label: 'Online', order_mail_label: 'Per E-Mail',
        order_online_qr: 'QR-Code scannen oder Link öffnen. Die Artikel liegen dann direkt im Checkout, Zahlung auf Rechnung möglich.',
        order_online: 'Link öffnen. Die Artikel liegen dann direkt im Checkout, Zahlung auf Rechnung möglich.',
        order_link: 'Jetzt online bestellen',
        order_mail: 'Bestellung unter Angabe der Angebotsnummer {number} an:',
        footer_terms: 'Es gelten unsere Allgemeinen Geschäftsbedingungen:',
        footer_auto: 'Dieses Angebot wurde automatisch erstellt und ist ohne Unterschrift gültig.', page: 'Seite',
        file: 'Angebot',
        legal: '{company}, Sitz {seat}, Amtsgericht {court} {hrb}, Geschäftsführer: {md}, USt-IdNr. {vat}'
      }
    },
    en: {
      title_pdf: 'Quotation as PDF',
      lead_pdf: 'We will create a PDF quotation with all items and prices from your cart.',
      submit_pdf: 'Create PDF quotation', busy_pdf: 'Creating PDF\u2026',
      done_pdf_title: 'Your quotation is ready', done_pdf_text: 'The PDF has been downloaded. You can order right here or at any time later via the link in the PDF.',
      again: 'Download PDF again',
      err_empty: 'Your cart is empty.',
      err_pdf: 'The PDF quotation could not be created just now. Please try again in a few minutes or write to us at {email}.',
      verify_title: 'Almost done',
      verify_pdf: 'Please confirm on the next page that you are not a robot. Your PDF quotation will then download automatically.',
      verify_btn: 'Continue',
      pdf: {
        title: 'Quotation', number: 'Quotation no.', date: 'Date', valid: 'Valid until', reference: 'Your reference',
        col_pos: 'Pos.', col_item: 'Item', col_qty: 'Qty', col_unit: 'Unit price', col_total: 'Total', sku: 'Item no.',
        product_link: 'View product page',
        discount_note: 'incl. volume discount', subtotal: 'Items total', cart_discount: 'Discount', total: 'Total net',
        vat: 'VAT ID', ship_to: 'Delivery address', same_address: 'same as billing address',
        ship_row: 'Shipping {name}', ship_alt: 'Alternative: {name}',
        ship_note_rates: 'Stock status and delivery times as of the quotation date, subject to prior sale.\nOrders by email: payment 30 days net, we reserve the right to request prepayment.',
        net_note: 'All prices net plus statutory VAT. Deliveries to businesses in other EU member states with a valid VAT ID and deliveries to non-EU countries are VAT-exempt.',
        ship_note: 'Plus shipping costs.\nStock status and delivery times as of the quotation date, subject to prior sale.\nOrders by email: payment 30 days net, we reserve the right to request prepayment.',
        order_title: 'How to order',
        order_online_label: 'Online', order_mail_label: 'By email',
        order_online_qr: 'Scan the QR code or open the link. The items are added straight to checkout, payment by invoice available.',
        order_online: 'Open the link. The items are added straight to checkout, payment by invoice available.',
        order_link: 'Order online now',
        order_mail: 'Please send your order, referencing quotation no. {number}, to:',
        footer_terms: 'Our general terms and conditions apply:',
        footer_auto: 'This quotation was generated automatically and is valid without signature.', page: 'Page',
        file: 'Quotation',
        legal: '{company}, registered office {seat}, Germany, register court Amtsgericht {court} {hrb}, managing director: {md}, VAT ID {vat}'
      }
    },
    nl: {
      title_pdf: 'Offerte als pdf',
      lead_pdf: 'Wij maken voor u een pdf-offerte met alle artikelen en prijzen uit uw winkelwagen.',
      submit_pdf: 'Offerte als pdf maken', busy_pdf: 'Pdf wordt gemaakt\u2026',
      done_pdf_title: 'Uw offerte is klaar', done_pdf_text: 'De pdf is gedownload. U kunt direct hier bestellen of op elk later moment via de link in de pdf.',
      again: 'Pdf opnieuw downloaden',
      err_empty: 'Uw winkelwagen is leeg.',
      err_pdf: 'De pdf-offerte kon op dit moment niet worden gemaakt. Probeer het over een paar minuten opnieuw of schrijf ons op {email}.',
      verify_title: 'Bijna klaar',
      verify_pdf: 'Bevestig op de volgende pagina dat u geen robot bent. Daarna wordt uw pdf-offerte automatisch gedownload.',
      verify_btn: 'Verder',
      pdf: {
        title: 'Offerte', number: 'Offertenr.', date: 'Datum', valid: 'Geldig tot', reference: 'Uw referentie',
        col_pos: 'Pos.', col_item: 'Artikel', col_qty: 'Aantal', col_unit: 'Stukprijs', col_total: 'Totaal', sku: 'Art.nr.',
        product_link: 'Naar de productpagina',
        discount_note: 'incl. staffelkorting', subtotal: 'Totaal artikelen', cart_discount: 'Korting', total: 'Totaal netto',
        vat: 'Btw-nr.', ship_to: 'Afleveradres', same_address: 'gelijk aan factuuradres',
        ship_row: 'Verzending {name}', ship_alt: 'Alternatief: {name}',
        ship_note_rates: 'Beschikbaarheid en levertijden volgens stand op de offertedatum, onder voorbehoud van tussentijdse verkoop.\nBestelling per e-mail: betaling binnen 30 dagen netto, vooruitbetaling voorbehouden.',
        net_note: 'Alle prijzen excl. wettelijke btw. Leveringen aan bedrijven in andere EU-lidstaten met geldig btw-nummer en leveringen buiten de EU zijn vrijgesteld van btw.',
        ship_note: 'Excl. verzendkosten.\nBeschikbaarheid en levertijden volgens stand op de offertedatum, onder voorbehoud van tussentijdse verkoop.\nBestelling per e-mail: betaling binnen 30 dagen netto, vooruitbetaling voorbehouden.',
        order_title: 'Zo bestelt u',
        order_online_label: 'Online', order_mail_label: 'Per e-mail',
        order_online_qr: 'Scan de QR-code of open de link. De artikelen staan dan direct in de checkout, betaling op factuur mogelijk.',
        order_online: 'Open de link. De artikelen staan dan direct in de checkout, betaling op factuur mogelijk.',
        order_link: 'Online bestellen',
        order_mail: 'Stuur uw bestelling met vermelding van offertenr. {number} naar:',
        footer_terms: 'Onze algemene verkoopvoorwaarden zijn van toepassing:',
        footer_auto: 'Deze offerte is automatisch gegenereerd en geldig zonder handtekening.', page: 'Pagina',
        file: 'Offerte',
        legal: '{company}, vestiging {seat}, Duitsland, handelsregister Amtsgericht {court} {hrb}, directeur: {md}, btw-nr. {vat}'
      }
    },
    pl: {
      title_pdf: 'Oferta w PDF',
      lead_pdf: 'Przygotujemy dla Pa\u0144stwa ofert\u0119 w PDF ze wszystkimi artyku\u0142ami i cenami z koszyka.',
      submit_pdf: 'Utw\u00f3rz ofert\u0119 PDF', busy_pdf: 'Tworzenie PDF\u2026',
      done_pdf_title: 'Oferta jest gotowa', done_pdf_text: 'PDF zosta\u0142 pobrany. Zam\u00f3wienie mo\u017cna z\u0142o\u017cy\u0107 od razu tutaj lub w dowolnym momencie p\u00f3\u017aniej przez link w PDF.',
      again: 'Pobierz ponownie PDF',
      err_empty: 'Koszyk jest pusty.',
      err_pdf: 'W tej chwili nie uda\u0142o si\u0119 utworzy\u0107 oferty PDF. Prosimy spr\u00f3bowa\u0107 ponownie za kilka minut lub napisa\u0107 do nas na {email}.',
      verify_title: 'Prawie gotowe',
      verify_pdf: 'Prosimy potwierdzi\u0107 na nast\u0119pnej stronie, \u017ce nie s\u0105 Pa\u0144stwo robotem. Nast\u0119pnie oferta PDF zostanie pobrana automatycznie.',
      verify_btn: 'Dalej',
      pdf: {
        title: 'Oferta', number: 'Nr oferty', date: 'Data', valid: 'Wa\u017cna do', reference: 'Pa\u0144stwa oznaczenie',
        col_pos: 'Poz.', col_item: 'Artyku\u0142', col_qty: 'Ilo\u015b\u0107', col_unit: 'Cena jedn.', col_total: 'Warto\u015b\u0107', sku: 'Nr art.',
        product_link: 'Do strony produktu',
        discount_note: 'z rabatem ilo\u015bciowym', subtotal: 'Suma pozycji', cart_discount: 'Rabat', total: 'Razem netto',
        vat: 'NIP UE', ship_to: 'Adres dostawy', same_address: 'jak adres rozliczeniowy',
        ship_row: 'Wysy\u0142ka {name}', ship_alt: 'Alternatywnie: {name}',
        ship_note_rates: 'Dost\u0119pno\u015b\u0107 i terminy dostawy wed\u0142ug stanu z dnia oferty, do wyczerpania zapas\u00f3w.\nZam\u00f3wienie e-mailem: p\u0142atno\u015b\u0107 30 dni netto, zastrzegamy sobie przedp\u0142at\u0119.',
        net_note: 'Wszystkie ceny netto, plus obowi\u0105zuj\u0105cy VAT. Dostawy do firm z innych pa\u0144stw cz\u0142onkowskich UE z wa\u017cnym numerem NIP UE oraz dostawy poza UE s\u0105 zwolnione z VAT.',
        ship_note: 'Plus koszty wysy\u0142ki.\nDost\u0119pno\u015b\u0107 i terminy dostawy wed\u0142ug stanu z dnia oferty, do wyczerpania zapas\u00f3w.\nZam\u00f3wienie e-mailem: p\u0142atno\u015b\u0107 30 dni netto, zastrzegamy sobie przedp\u0142at\u0119.',
        order_title: 'Jak zam\u00f3wi\u0107',
        order_online_label: 'Online', order_mail_label: 'E-mailem',
        order_online_qr: 'Prosimy zeskanowa\u0107 kod QR lub otworzy\u0107 link. Artyku\u0142y b\u0119d\u0105 od razu w kasie, mo\u017cliwa p\u0142atno\u015b\u0107 na faktur\u0119.',
        order_online: 'Prosimy otworzy\u0107 link. Artyku\u0142y b\u0119d\u0105 od razu w kasie, mo\u017cliwa p\u0142atno\u015b\u0107 na faktur\u0119.',
        order_link: 'Zam\u00f3w online',
        order_mail: 'Zam\u00f3wienie z numerem oferty {number} prosimy przes\u0142a\u0107 na adres:',
        footer_terms: 'Obowi\u0105zuj\u0105 nasze og\u00f3lne warunki sprzeda\u017cy:',
        footer_auto: 'Ta oferta zosta\u0142a wygenerowana automatycznie i jest wa\u017cna bez podpisu.', page: 'Strona',
        file: 'Oferta',
        legal: '{company}, siedziba {seat}, Niemcy, rejestr handlowy Amtsgericht {court} {hrb}, prezes zarz\u0105du: {md}, NIP UE {vat}'
      }
    },
    es: {
      title_pdf: 'Oferta en PDF',
      lead_pdf: 'Creamos para usted una oferta en PDF con todos los art\u00edculos y precios de su carrito.',
      submit_pdf: 'Crear oferta en PDF', busy_pdf: 'Creando el PDF\u2026',
      done_pdf_title: 'Su oferta est\u00e1 lista', done_pdf_text: 'El PDF se ha descargado. Puede hacer el pedido directamente aqu\u00ed o en cualquier momento m\u00e1s adelante mediante el enlace del PDF.',
      again: 'Descargar de nuevo el PDF',
      err_empty: 'Su carrito est\u00e1 vac\u00edo.',
      err_pdf: 'En este momento no se ha podido crear la oferta en PDF. Int\u00e9ntelo de nuevo en unos minutos o escr\u00edbanos a {email}.',
      verify_title: 'Casi listo',
      verify_pdf: 'Confirme en la p\u00e1gina siguiente que no es un robot. Despu\u00e9s, su oferta en PDF se descargar\u00e1 autom\u00e1ticamente.',
      verify_btn: 'Continuar',
      pdf: {
        title: 'Oferta', number: 'N.\u00ba de oferta', date: 'Fecha', valid: 'V\u00e1lida hasta', reference: 'Su referencia',
        col_pos: 'Pos.', col_item: 'Art\u00edculo', col_qty: 'Cant.', col_unit: 'Precio unitario', col_total: 'Total', sku: 'Ref.',
        product_link: 'Ver la p\u00e1gina del producto',
        discount_note: 'descuento por cantidad incluido', subtotal: 'Total art\u00edculos', cart_discount: 'Descuento', total: 'Total neto',
        vat: 'NIF-IVA', ship_to: 'Direcci\u00f3n de entrega', same_address: 'igual que la direcci\u00f3n de facturaci\u00f3n',
        ship_row: 'Env\u00edo {name}', ship_alt: 'Alternativa: {name}',
        ship_note_rates: 'Disponibilidad y plazos de entrega a la fecha de la oferta, salvo venta previa.\nPedido por correo electr\u00f3nico: pago a 30 d\u00edas neto, nos reservamos el pago por adelantado.',
        net_note: 'Todos los precios sin IVA, m\u00e1s el IVA legal. Las entregas a empresas de otros Estados miembros de la UE con NIF-IVA v\u00e1lido y las entregas fuera de la UE est\u00e1n exentas de IVA.',
        ship_note: 'Gastos de env\u00edo no incluidos.\nDisponibilidad y plazos de entrega a la fecha de la oferta, salvo venta previa.\nPedido por correo electr\u00f3nico: pago a 30 d\u00edas neto, nos reservamos el pago por adelantado.',
        order_title: 'C\u00f3mo hacer el pedido',
        order_online_label: 'Online', order_mail_label: 'Por correo electr\u00f3nico',
        order_online_qr: 'Escanee el c\u00f3digo QR o abra el enlace. Los art\u00edculos estar\u00e1n directamente en el checkout, es posible pagar con factura.',
        order_online: 'Abra el enlace. Los art\u00edculos estar\u00e1n directamente en el checkout, es posible pagar con factura.',
        order_link: 'Pedir online',
        order_mail: 'Env\u00ede su pedido indicando el n.\u00ba de oferta {number} a:',
        footer_terms: 'Se aplican nuestras condiciones generales de venta:',
        footer_auto: 'Esta oferta se ha generado autom\u00e1ticamente y es v\u00e1lida sin firma.', page: 'P\u00e1gina',
        file: 'Oferta',
        legal: '{company}, sede {seat}, Alemania, registro mercantil Amtsgericht {court} {hrb}, director general: {md}, NIF-IVA {vat}'
      }
    },
    it: {
      title_pdf: 'Offerta in PDF',
      lead_pdf: 'Creiamo per Lei un\'offerta PDF con tutti gli articoli e i prezzi del Suo carrello.',
      submit_pdf: 'Crea offerta PDF', busy_pdf: 'Creazione del PDF\u2026',
      done_pdf_title: 'La Sua offerta \u00e8 pronta', done_pdf_text: 'Il PDF \u00e8 stato scaricato. Pu\u00f2 ordinare direttamente qui o in qualsiasi momento in seguito tramite il link nel PDF.',
      again: 'Scarica di nuovo il PDF',
      err_empty: 'Il carrello \u00e8 vuoto.',
      err_pdf: 'Al momento non \u00e8 stato possibile creare l\'offerta PDF. Riprovi tra qualche minuto o ci scriva a {email}.',
      verify_title: 'Quasi fatto',
      verify_pdf: 'Confermi nella pagina successiva di non essere un robot. Dopodich\u00e9 la Sua offerta PDF verr\u00e0 scaricata automaticamente.',
      verify_btn: 'Continua',
      pdf: {
        title: 'Offerta', number: 'N. offerta', date: 'Data', valid: 'Valida fino al', reference: 'Suo riferimento',
        col_pos: 'Pos.', col_item: 'Articolo', col_qty: 'Qt\u00e0', col_unit: 'Prezzo unitario', col_total: 'Totale', sku: 'Cod.',
        product_link: 'Vai alla pagina prodotto',
        discount_note: 'sconto a scaglioni incluso', subtotal: 'Totale articoli', cart_discount: 'Sconto', total: 'Totale netto',
        vat: 'P. IVA', ship_to: 'Indirizzo di consegna', same_address: 'uguale all\'indirizzo di fatturazione',
        ship_row: 'Spedizione {name}', ship_alt: 'Alternativa: {name}',
        ship_note_rates: 'Disponibilit\u00e0 e tempi di consegna alla data dell\'offerta, salvo venduto.\nOrdine via e-mail: pagamento a 30 giorni netti, ci riserviamo il pagamento anticipato.',
        net_note: 'Tutti i prezzi sono al netto dell\'IVA di legge. Le consegne a imprese di altri Stati membri dell\'UE con partita IVA valida e le consegne extra UE sono esenti da IVA.',
        ship_note: 'Spese di spedizione escluse.\nDisponibilit\u00e0 e tempi di consegna alla data dell\'offerta, salvo venduto.\nOrdine via e-mail: pagamento a 30 giorni netti, ci riserviamo il pagamento anticipato.',
        order_title: 'Come ordinare',
        order_online_label: 'Online', order_mail_label: 'Via e-mail',
        order_online_qr: 'Scansioni il codice QR o apra il link. Gli articoli si trovano direttamente nel checkout, \u00e8 possibile il pagamento su fattura.',
        order_online: 'Apra il link. Gli articoli si trovano direttamente nel checkout, \u00e8 possibile il pagamento su fattura.',
        order_link: 'Ordina online',
        order_mail: 'Invii il Suo ordine indicando il n. offerta {number} a:',
        footer_terms: 'Si applicano le nostre condizioni generali di vendita:',
        footer_auto: 'Questa offerta \u00e8 stata generata automaticamente ed \u00e8 valida senza firma.', page: 'Pagina',
        file: 'Offerta',
        legal: '{company}, sede {seat}, Germania, registro delle imprese Amtsgericht {court} {hrb}, amministratore delegato: {md}, P. IVA {vat}'
      }
    },
    fr: {
      title_pdf: 'Devis en PDF',
      lead_pdf: 'Nous cr\u00e9ons pour vous un devis PDF avec tous les articles et prix de votre panier.',
      submit_pdf: 'Cr\u00e9er le devis PDF', busy_pdf: 'Cr\u00e9ation du PDF\u2026',
      done_pdf_title: 'Votre devis est pr\u00eat', done_pdf_text: 'Le PDF a \u00e9t\u00e9 t\u00e9l\u00e9charg\u00e9. Vous pouvez commander directement ici ou \u00e0 tout moment plus tard via le lien dans le PDF.',
      again: 'T\u00e9l\u00e9charger \u00e0 nouveau le PDF',
      err_empty: 'Votre panier est vide.',
      err_pdf: 'Le devis PDF n\'a pas pu \u00eatre cr\u00e9\u00e9 pour le moment. Veuillez r\u00e9essayer dans quelques minutes ou nous \u00e9crire \u00e0 {email}.',
      verify_title: 'Presque termin\u00e9',
      verify_pdf: 'Veuillez confirmer sur la page suivante que vous n\'\u00eates pas un robot. Votre devis PDF sera ensuite t\u00e9l\u00e9charg\u00e9 automatiquement.',
      verify_btn: 'Continuer',
      pdf: {
        title: 'Devis', number: 'N\u00b0 de devis', date: 'Date', valid: 'Valable jusqu\'au', reference: 'Votre r\u00e9f\u00e9rence',
        col_pos: 'Pos.', col_item: 'Article', col_qty: 'Qt\u00e9', col_unit: 'Prix unitaire', col_total: 'Total', sku: 'R\u00e9f.',
        product_link: 'Voir la page produit',
        discount_note: 'remise d\u00e9gressive incluse', subtotal: 'Total des articles', cart_discount: 'Remise', total: 'Total HT',
        vat: 'N\u00b0 TVA', ship_to: 'Adresse de livraison', same_address: 'identique \u00e0 l\'adresse de facturation',
        ship_row: 'Exp\u00e9dition {name}', ship_alt: 'Alternative : {name}',
        ship_note_rates: 'Disponibilit\u00e9 et d\u00e9lais de livraison \u00e0 la date du devis, sous r\u00e9serve de vente interm\u00e9diaire.\nCommande par e-mail : paiement \u00e0 30 jours net, paiement anticip\u00e9 r\u00e9serv\u00e9.',
        net_note: 'Tous les prix s\'entendent HT, TVA l\u00e9gale en sus. Les livraisons aux entreprises d\'autres \u00c9tats membres de l\'UE disposant d\'un num\u00e9ro de TVA valide et les livraisons hors UE sont exon\u00e9r\u00e9es de TVA.',
        ship_note: 'Frais de port en sus.\nDisponibilit\u00e9 et d\u00e9lais de livraison \u00e0 la date du devis, sous r\u00e9serve de vente interm\u00e9diaire.\nCommande par e-mail : paiement \u00e0 30 jours net, paiement anticip\u00e9 r\u00e9serv\u00e9.',
        order_title: 'Comment commander',
        order_online_label: 'En ligne', order_mail_label: 'Par e-mail',
        order_online_qr: 'Scannez le QR code ou ouvrez le lien. Les articles se trouvent alors directement dans le checkout, paiement sur facture possible.',
        order_online: 'Ouvrez le lien. Les articles se trouvent alors directement dans le checkout, paiement sur facture possible.',
        order_link: 'Commander en ligne',
        order_mail: 'Veuillez envoyer votre commande en indiquant le n\u00b0 de devis {number} \u00e0 :',
        footer_terms: 'Nos conditions g\u00e9n\u00e9rales de vente s\'appliquent :',
        footer_auto: 'Ce devis a \u00e9t\u00e9 g\u00e9n\u00e9r\u00e9 automatiquement et est valable sans signature.', page: 'Page',
        file: 'Devis',
        legal: '{company}, si\u00e8ge {seat}, Allemagne, registre du commerce Amtsgericht {court} {hrb}, g\u00e9rant : {md}, N\u00b0 TVA {vat}'
      }
    }
  };
  var lang = TX[cfg.lang] ? cfg.lang : 'en';
  var T = TX[lang];

  /* Wartungseinsatz laut Wartungsvertrag (seit 3.15) */
  var WV_PCT = 15, WV_REP = 'Maximilian Schwartz';
  var WV_TX = {
    de: { note: 'Wartungsvertrag: 15 % Rabatt', rep: 'Vertriebsmitarbeiter', sn: 'Anlage SN ' },
    en: { note: 'Maintenance contract: 15 % discount', rep: 'Sales representative', sn: 'Machine SN ' },
    fr: { note: 'Contrat de maintenance : remise de 15 %', rep: 'Commercial', sn: 'Installation SN ' },
    it: { note: 'Contratto di manutenzione: sconto del 15 %', rep: 'Referente commerciale', sn: 'Impianto SN ' },
    es: { note: 'Contrato de mantenimiento: 15 % de descuento', rep: 'Comercial', sn: 'Instalaci\u00f3n SN ' },
    pl: { note: 'Umowa serwisowa: rabat 15 %', rep: 'Przedstawiciel handlowy', sn: 'Instalacja SN ' },
    nl: { note: 'Onderhoudscontract: 15 % korting', rep: 'Vertegenwoordiger', sn: 'Installatie SN ' }
  };
  function applyWv(p, sn) {
    var sum = 0;
    p.items = p.items.map(function (it) {
      var x = {}, k; for (k in it) x[k] = it[k];
      x.listUnit = it.unit; x.unit = Math.round(it.unit * (100 - WV_PCT) / 100); x.line = x.unit * it.qty; x.discounted = false;
      sum += x.line; return x;
    });
    p.subtotal = sum; p.discount = 0; p.discountPct = ''; p.total = sum;
    p.wv = { sn: String(sn || '').trim() };
  }

  var LIBS = {
    jspdf: 'https://cdn.jsdelivr.net/npm/jspdf@2.5.2/dist/jspdf.umd.min.js',
    qr: 'https://cdn.jsdelivr.net/npm/qrcode-generator@1.4.4/qrcode.js',
    builder: cfg.builder
  };
  function log() {
    if (window.console && console.info) console.info.apply(console, ['[tsi-quote]'].concat([].slice.call(arguments)));
  }
  var loading = {};
  function loadScript(src) {
    if (!loading[src]) {
      loading[src] = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src; s.async = true;
        s.onload = resolve;
        s.onerror = function () { delete loading[src]; reject(new Error('load ' + src)); };
        document.head.appendChild(s);
      });
    }
    return loading[src];
  }
  function preload() {
    loadScript(LIBS.jspdf).catch(function () {});
    loadScript(LIBS.qr).catch(function () {});
    loadScript(LIBS.builder).catch(function () {});
  }

  var logoCache = null;
  function loadLogo() {
    if (logoCache) return Promise.resolve(logoCache);
    return fetch(cfg.logo).then(function (r) { return r.blob(); }).then(function (b) {
      return new Promise(function (resolve) {
        var fr = new FileReader();
        fr.onload = function () {
          var img = new Image();
          img.onload = function () {
            logoCache = { dataUrl: fr.result, w: img.naturalWidth, h: img.naturalHeight };
            /* Transparenten bzw. weissen Rand abschneiden, damit die sichtbare Logohoehe exakt passt */
            try {
              var cv = document.createElement('canvas'); cv.width = img.naturalWidth; cv.height = img.naturalHeight;
              var cx = cv.getContext('2d'); cx.drawImage(img, 0, 0);
              var px = cx.getImageData(0, 0, cv.width, cv.height).data, x0 = cv.width, y0 = cv.height, x1 = -1, y1 = -1;
              for (var yy = 0; yy < cv.height; yy++) for (var xx = 0; xx < cv.width; xx++) {
                var o = (yy * cv.width + xx) * 4;
                if (px[o + 3] > 10 && (px[o] < 245 || px[o + 1] < 245 || px[o + 2] < 245)) {
                  if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy;
                }
              }
              if (x1 > x0 && y1 > y0) {
                var tw = x1 - x0 + 1, th = y1 - y0 + 1, tc = document.createElement('canvas');
                tc.width = tw; tc.height = th; tc.getContext('2d').drawImage(cv, x0, y0, tw, th, 0, 0, tw, th);
                logoCache = { dataUrl: tc.toDataURL('image/png'), w: tw, h: th };
              }
            } catch (err) {}
            resolve(logoCache);
          };
          img.onerror = function () { resolve(null); };
          img.src = fr.result;
        };
        fr.onerror = function () { resolve(null); };
        fr.readAsDataURL(b);
      });
    }).catch(function () { return null; });
  }

  var $ = function (sel) { return dlg.querySelector(sel); };
  var form = $('form');
  var errBox = $('[data-quote-error]');
  var submitBtn = $('[data-quote-submit]');
  var lastPdf = null;
  var pausedTrap = null;
  var backdrop = document.querySelector('[data-quote-backdrop]');
  var asModal = false, skipClose = 0, currentView = 'form', downOnBackdrop = false;
  var PENDING = 'tsi-quote-pending';
  var PENDING_MAX_AGE = 30 * 60 * 1000;

  /* Abschlussansicht, TL = Texte in der Angebotssprache */
  function showDone(number, TL, text) {
    TL = TL || T;
    $('[data-quote-done-title]').textContent = TL.done_pdf_title;
    $('[data-quote-done-text]').textContent = text || TL.done_pdf_text;
    var num = $('[data-quote-done-num]');
    if (num) { num.textContent = number || ''; num.hidden = !number; }
    $('[data-quote-again]').hidden = false;
    $('[data-quote-checkout]').hidden = false;
    showView('done');
  }
  /* Checkout-Button im Dialog auf den vorbelegten Bestelllink setzen (gleiche Artikel, Angebotsnummer als Attribut) */
  function setCheckout(p) {
    var a = $('[data-quote-checkout]'), u = orderLinkFull(p);
    if (a && u) a.setAttribute('href', u);
    if (a && p && p.wv) a.hidden = true;
  }
  /* Shopify verlangt die sichtbare Captcha-Pruefung: eigene Ansicht, Link fuehrt zur Pruefseite (gleicher Tab) */
  function showVerify(url) {
    $('[data-quote-verify-title]').textContent = T.verify_title;
    $('[data-quote-verify-text]').textContent = T.verify_pdf;
    var a = $('[data-quote-verify-link]');
    a.setAttribute('href', url);
    a.textContent = T.verify_btn;
    showView('verify');
  }
  function savePending(data) {
    try { localStorage.setItem(PENDING, JSON.stringify({ t: Date.now(), k: packPayload(data) })); } catch (err) { log('pending save error', err); }
  }
  function takePending() {
    var p = null;
    try { p = JSON.parse(localStorage.getItem(PENDING) || 'null'); localStorage.removeItem(PENDING); } catch (err) {}
    return p && p.k && Date.now() - p.t < PENDING_MAX_AGE ? p : null;
  }

  function fill(str, map) {
    return str.replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function showView(name) {
    currentView = name;
    dlg.querySelectorAll('[data-quote-view]').forEach(function (v) { v.hidden = v.getAttribute('data-quote-view') !== name; });
  }
  function setBusy(on, text) {
    submitBtn.disabled = on;
    submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    submitBtn.textContent = on ? (text || T.busy_pdf) : T.submit_pdf;
  }
  function showError(msg) { errBox.textContent = msg || ''; errBox.hidden = !msg; }

  /* Adressfelder: Laenderliste der Lieferadresse aus der Rechnungsadresse uebernehmen, Lieferadresse ein-/ausblenden */
  var FIELDS = ['company', 'name', 'email', 'b_street', 'b_zip', 'b_city', 'b_country', 'vat',
    's_company', 's_name', 's_street', 's_street2', 's_zip', 's_city', 's_country'];
  var shipToggle = $('[data-quote-ship-toggle]');
  var shipBox = $('[data-quote-ship]');
  (function initCountries() {
    var src = form.elements.b_country, dst = form.elements.s_country;
    if (src && dst && !dst.options.length) { dst.innerHTML = src.innerHTML; dst.value = src.value; }
  })();
  function setShip(on) {
    if (!shipToggle || !shipBox) return;
    shipToggle.checked = !!on;
    shipBox.hidden = !on;
    shipBox.disabled = !on;
  }
  if (shipToggle) shipToggle.addEventListener('change', function () {
    setShip(shipToggle.checked);
    var sc = form.elements.s_company;
    if (shipToggle.checked && sc && !sc.value) sc.value = form.elements.company.value;
  });
  /* USt-IdNr. nur fuer EU-Laender ausser Deutschland (steuerfreie innergemeinschaftliche Lieferung), dann Pflicht */
  var EU_VAT = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV',
    'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];
  var vatBox = $('[data-quote-vat]');
  function updateVat() {
    var inp = form.elements.vat, c = form.elements.b_country;
    if (!vatBox || !inp || !c) return;
    var need = EU_VAT.indexOf(c.value) >= 0;
    vatBox.hidden = !need;
    inp.disabled = !need;
    inp.required = need;
  }
  if (form.elements.b_country) form.elements.b_country.addEventListener('change', updateVat);
  updateVat();
  function addrDiff(o) {
    return !!o.s_street && (o.s_street !== o.b_street || o.s_zip !== o.b_zip || o.s_city !== o.b_city || o.s_country !== o.b_country);
  }
  /* Vorbelegung einmal je Seitenaufruf: eingeloggt zuerst Kundenkonto, sonst zuerst letzte Eingabe */
  var prefilled = false;
  function prefill() {
    if (prefilled) return;
    prefilled = true;
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem('tsi-quote-contact') || '{}') || {}; } catch (e) {}
    var acc = cfg.customer || {};
    var sources = acc.loggedIn ? [acc, saved] : [saved, acc];
    FIELDS.forEach(function (k) {
      var el = form.elements[k];
      if (!el) return;
      for (var i = 0; i < sources.length; i++) {
        var v = sources[i] && sources[i][k];
        if (v) { el.value = v; break; }
      }
    });
    var diff = acc.loggedIn ? addrDiff(acc) : !!saved.ship_diff;
    setShip(diff);
    updateVat();
    if (diff && form.elements.s_company && !form.elements.s_company.value) form.elements.s_company.value = form.elements.company.value;
  }
  function val(k) {
    var el = form.elements[k];
    return el && !el.disabled ? String(el.value || '').trim() : '';
  }
  function countryName(k) {
    var el = form.elements[k];
    return el && el.selectedIndex >= 0 && el.options[el.selectedIndex] ? el.options[el.selectedIndex].text.trim() : '';
  }
  function addrLine(a) {
    if (!a) return '';
    return [a.company, a.name, a.street, a.street2, [a.zip, a.city].join(' ').trim(), a.countryName].filter(function (x) { return x; }).join(', ');
  }

  function openDialog(trigger) {
    $('[data-quote-title]').textContent = T.title_pdf;
    $('[data-quote-lead]').textContent = T.lead_pdf;
    showError(''); setBusy(false); showView('form');
    var drawer = trigger && trigger.closest('drawer-element');
    if (drawer && drawer.trap && drawer.trap.pause) { drawer.trap.pause(); pausedTrap = drawer.trap; }
    prefill();
    preload();
    openModal();
  }
  /* Modal oeffnen (Fokus bleibt im Dialog, Hintergrund inert) */
  function openModal() {
    if (dlg.open) return;
    dlg.classList.remove('is-nonmodal');
    if (backdrop) backdrop.hidden = true;
    dlg.showModal();
    asModal = true;
  }
  /* Vor dem Captcha: nicht-modal weiterfuehren, gleiches Aussehen, Captcha kann darueber liegen */
  function demote() {
    if (!dlg.open || !asModal) return;
    skipClose++;
    dlg.close();
    dlg.classList.add('is-nonmodal');
    if (backdrop) backdrop.hidden = false;
    dlg.show();
    asModal = false;
  }
  /* Theme-dialog.js schliesst bei Escape jeden offenen <dialog> ueber dialog.trap, deshalb Platzhalter */
  if (!dlg.trap) dlg.trap = { activate: function () {}, deactivate: function () {} };
  dlg.addEventListener('close', function () {
    if (skipClose) { skipClose--; return; }
    asModal = false;
    dlg.classList.remove('is-nonmodal');
    if (backdrop) backdrop.hidden = true;
    if (pausedTrap && pausedTrap.unpause) pausedTrap.unpause();
    pausedTrap = null;
  });
  /* Schliessen: immer ueber X / Abbrechen / Schliessen. Klick daneben nur ausserhalb des Formulars und nur, wenn
     Druecken und Loslassen beide auf dem Hintergrund liegen (kein versehentliches Schliessen beim Markieren). */
  function onBackdrop(t) { return t === dlg || t === backdrop; }
  document.addEventListener('pointerdown', function (e) { downOnBackdrop = dlg.open && onBackdrop(e.target); }, true);
  function backdropClick(e) {
    var ok = downOnBackdrop && onBackdrop(e.target) && currentView !== 'form';
    downOnBackdrop = false;
    if (ok) dlg.close();
  }
  dlg.addEventListener('click', function (e) {
    if (e.target.closest('[data-quote-close]')) { dlg.close(); return; }
    backdropClick(e);
  });
  if (backdrop) backdrop.addEventListener('click', backdropClick);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tsi-quote-open]');
    if (!btn) return;
    e.preventDefault();
    openDialog(btn);
  });

  function money(c) {
    var n = (c / 100).toFixed(2).split('.');
    return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1] + ' \u20AC';
  }
  function quoteNumber() {
    var d = new Date(), abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', r = '';
    var rnd = new Uint8Array(4);
    (window.crypto || window.msCrypto).getRandomValues(rnd);
    for (var i = 0; i < 4; i++) r += abc[rnd[i] % abc.length];
    return 'WS-' + String(d.getFullYear()).slice(2) + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2) + '-' + r;
  }

  /* Angebotsdaten kompakt im Link (#tsi-quote=...) ablegen, damit das identische PDF aus der Lead-Mail
     jederzeit neu erzeugt werden kann. Der Hash wird nicht an den Server uebertragen. */
  function b64urlEncode(str) {
    return btoa(unescape(encodeURIComponent(str))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64urlDecode(str) {
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4) str += '=';
    return decodeURIComponent(escape(atob(str)));
  }
  function packPayload(p) {
    return {
      v: 1, l: p.lang, n: p.number, d: p.date.toISOString(), u: p.validUntil.toISOString(),
      c: [p.customer.company, p.customer.name, p.customer.email, p.customer.reference,
        p.customer.billing ? [p.customer.billing.street, p.customer.billing.zip, p.customer.billing.city, p.customer.billing.country, p.customer.billing.countryName] : 0,
        p.customer.shipping ? [p.customer.shipping.company, p.customer.shipping.name, p.customer.shipping.street, p.customer.shipping.street2, p.customer.shipping.zip, p.customer.shipping.city, p.customer.shipping.country, p.customer.shipping.countryName] : 0,
        p.customer.vat || ''],
      i: p.items.map(function (it) { return [it.variantId, it.title, it.variant, it.sku, it.qty, it.unit, it.line, it.discounted ? 1 : 0, it.stock || '', it.stockColor || '', it.url || '', it.listUnit || 0]; }),
      s: p.subtotal, x: p.discount, xp: p.discountPct || '', t: p.total, o: p.orderUrl,
      w: p.wv ? [p.wv.sn || ''] : 0,
      sr: p.rates && p.rates.length ? [p.ratesTo || '', p.rates.map(function (r) { return [r.name, r.cents]; })] : 0
    };
  }
  function unpackPayload(k) {
    return {
      lang: TX[k.l] ? k.l : 'en', number: k.n, date: new Date(k.d), validUntil: new Date(k.u),
      customer: {
        company: k.c[0] || '', name: k.c[1] || '', email: k.c[2] || '', reference: k.c[3] || '',
        billing: Array.isArray(k.c[4]) ? { street: k.c[4][0] || '', zip: k.c[4][1] || '', city: k.c[4][2] || '', country: k.c[4][3] || '', countryName: k.c[4][4] || '' } : null,
        shipping: Array.isArray(k.c[5]) ? { company: k.c[5][0] || '', name: k.c[5][1] || '', street: k.c[5][2] || '', street2: k.c[5][3] || '', zip: k.c[5][4] || '', city: k.c[5][5] || '', country: k.c[5][6] || '', countryName: k.c[5][7] || '' } : null,
        vat: k.c[6] || ''
      },
      items: k.i.map(function (a) { return { variantId: a[0], title: a[1], variant: a[2], sku: a[3], qty: a[4], unit: a[5], line: a[6], discounted: !!a[7], stock: a[8] || '', stockColor: a[9] || '', url: a[10] || '', listUnit: a[11] || 0 }; }),
      subtotal: k.s, discount: k.x, discountPct: k.xp || '', total: k.t, orderUrl: k.o,
      wv: Array.isArray(k.w) ? { sn: k.w[0] || '' } : null,
      ratesTo: Array.isArray(k.sr) ? k.sr[0] || '' : '',
      rates: Array.isArray(k.sr) && Array.isArray(k.sr[1]) ? k.sr[1].map(function (a) { return { name: a[0], cents: a[1] }; }) : null
    };
  }
  /* Bestelllink mit vorbelegtem Checkout (E-Mail, Lieferadresse); Shopify-Cart-Permalink-Parameter checkout[...] */
  function orderLinkFull(p) {
    if (!p || !p.orderUrl || p.wv) return '';
    var c = p.customer || {}, a = c.shipping || c.billing, q = [];
    function add(k, v) { v = String(v || '').trim(); if (v) q.push('checkout' + k + '=' + encodeURIComponent(v)); }
    add('[email]', c.email);
    if (a) {
      var nm = String((c.shipping && c.shipping.name) || c.name || '').trim(), sp = nm.lastIndexOf(' ');
      add('[shipping_address][first_name]', sp > 0 ? nm.slice(0, sp) : '');
      add('[shipping_address][last_name]', sp > 0 ? nm.slice(sp + 1) : nm);
      add('[shipping_address][company]', (c.shipping && c.shipping.company) || c.company);
      add('[shipping_address][address1]', a.street);
      add('[shipping_address][address2]', a.street2);
      add('[shipping_address][zip]', a.zip);
      add('[shipping_address][city]', a.city);
      add('[shipping_address][country]', a.country);
    }
    return q.length ? p.orderUrl + (p.orderUrl.indexOf('?') >= 0 ? '&' : '?') + q.join('&') : p.orderUrl;
  }
  function pdfLink(p) {
    return location.origin + cfg.root + '#tsi-quote=' + b64urlEncode(JSON.stringify(packPayload(p)));
  }
  function pdfData(p) {
    var TL = TX[p.lang] || T;
    return {
      t: TL.pdf, number: p.number, date: p.date, validUntil: p.validUntil, customer: p.customer, items: p.items,
      subtotal: p.subtotal, discount: p.discount, discountPct: p.discountPct || '', total: p.total,
      rates: p.rates || null, ratesTo: p.ratesTo || '', orderLink: orderLinkFull(p),
      shop: Object.assign({}, cfg.shop, { legal: cfg.legal ? fill(TL.pdf.legal, Object.assign({ company: cfg.shop.company }, cfg.legal)) : '' }),
      orderUrl: p.orderUrl, termsUrl: cfg.termsUrl
    };
  }
  /* Wartungseinsatz: Hinweis je Position, Vertriebsmitarbeiter, Anlage als Referenz, nur Bestellung per E-Mail */
  var pdfDataBase = pdfData;
  pdfData = function (p) {
    var data = pdfDataBase(p);
    if (!p.wv) return data;
    var W = WV_TX[p.lang] || WV_TX.en, c = {}, k;
    data.items = data.items.map(function (it) { var x = {}, j; for (j in it) x[j] = it[j]; x.wvNote = W.note; return x; });
    for (k in data.customer) c[k] = data.customer[k];
    var ref = W.sn + (p.wv.sn || '');
    if (p.wv.sn && String(c.reference || '').indexOf(ref) < 0) c.reference = (c.reference ? c.reference + ' \u00b7 ' : '') + ref;
    data.customer = c; data.salesRep = WV_REP; data.salesRepLabel = W.rep;
    data.noOnline = true; data.orderLink = ''; data.orderUrl = '';
    return data;
  };
  function renderPdf(p) {
    var data = pdfData(p);
    /* Seit 3.10: Zeichen ausserhalb von Windows-1252 (z. B. Polnisch) brauchen die Unicode-Schrift, sie liegt neben dem Layout-Skript. */
    var needFont = /[^\u0000-\u00ff\u20ac\u2013\u2014\u2018\u2019\u201a\u201c\u201d\u201e\u2020\u2021\u2022\u2026\u2030\u2039\u203a\u2122]/.test(JSON.stringify(data));
    var fontLoad = needFont ? loadScript(LIBS.builder.replace('tsi-quote-pdf.js', 'tsi-quote-font.js')).catch(function () {}) : Promise.resolve();
    return Promise.all([loadScript(LIBS.jspdf), loadScript(LIBS.builder), loadScript(LIBS.qr).catch(function () {}), loadLogo(), fontLoad]).then(function (res) {
      data.logo = res[3];
      if (needFont && window.TSI_PDF_FONT) data.uniFont = window.TSI_PDF_FONT;
      var doc = tsiBuildQuotePdf(window.jspdf.jsPDF, window.qrcode || null, data);
      var fileName = (TX[p.lang] || T).pdf.file + '_' + p.number + '.pdf';
      doc.save(fileName);
      lastPdf = { doc: doc, name: fileName };
      return doc;
    });
  }

  /* Lagerstatus je Warenkorbzeile (serverseitig, mengenbezogen). Schlaegt der Abruf fehl, entsteht das PDF ohne Status. */
  function fetchStock() {
    return fetch(cfg.root + '?sections=fetch-quote-stock', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (res) {
      var html = res && res['fetch-quote-stock'];
      var map = {};
      if (!html) return map;
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-tsi-quote-stock]');
      var list = el ? JSON.parse(el.textContent) : [];
      list.forEach(function (s) { if (s && s.key) map[s.key] = s; });
      return map;
    }).catch(function (err) { log('stock error', err); return {}; });
  }

  /* Versandoptionen fuer die Lieferadresse, wie im Checkout (UPS Carrier Calculated Shipping inkl. Aufschlag und
     Bearbeitungsgebuehr). Namen wie im Checkout (dort benennt Checkout Blocks die UPS-Dienste um). */
  function rateName(n) {
    var t = String(n || '').replace(/[\u00ae\u2122]/g, '').replace(/\s+/g, ' ').trim();
    if (/worldwide\s*saver|express\s*saver/i.test(t)) return 'UPS Express Saver';
    if (/express\s*12/i.test(t)) return 'UPS Express 12:00';
    if (/ups.*standard|^standard$/i.test(t)) return 'UPS Standard';
    return t;
  }
  function fetchRates(addr, cust) {
    if (!addr || !addr.country || !addr.zip) return Promise.resolve(null);
    cust = cust || {};
    var q = new URLSearchParams();
    function put(k, v) { v = String(v || '').trim(); if (v) q.append('shipping_address[' + k + ']', v); }
    var nm = String(addr.name || cust.name || '').trim(), sp = nm.lastIndexOf(' ');
    put('first_name', sp > 0 ? nm.slice(0, sp) : '');
    put('last_name', sp > 0 ? nm.slice(sp + 1) : nm);
    put('company', addr.company || cust.company);
    put('address1', addr.street);
    put('address2', addr.street2);
    put('zip', addr.zip);
    put('city', addr.city);
    put('country', addr.country);
    var base = cfg.root + 'cart/', qs = q.toString(), deadline = Date.now() + 9000;
    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
    function poll() {
      return fetch(base + 'async_shipping_rates.json?' + qs, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
        var j = null;
        try { j = t ? JSON.parse(t) : null; } catch (e) {}
        if (j && Array.isArray(j.shipping_rates)) return j.shipping_rates;
        if (Date.now() > deadline) return null;
        return wait(700).then(poll);
      });
    }
    return fetch(base + 'prepare_shipping_rates.json?' + qs, { method: 'POST', credentials: 'same-origin' }).then(poll).then(function (list) {
      if (!list || !list.length) return null;
      var seen = {}, out = [];
      list.forEach(function (r) {
        var cents = Math.round(parseFloat(r.price) * 100), name = rateName(r.presentment_name || r.name);
        if (!isFinite(cents) || !name || seen[name]) return;
        seen[name] = 1;
        out.push({ name: name, cents: cents });
      });
      out.sort(function (a, b) { return a.cents - b.cents; });
      log('rates', JSON.stringify(out));
      return out.length ? out : null;
    }).catch(function (err) { log('rates error', err); return null; });
  }

  /* Prozentsatz des Rabatts auf Bestellung: aus einer einzelnen prozentualen Rabattanwendung, sonst berechnet */
  function discountPct(cart, discount) {
    if (!discount || !cart.items_subtotal_price) return '';
    var apps = (cart.cart_level_discount_applications || []).filter(function (a) { return a && a.value_type === 'percentage'; });
    var pct = apps.length === 1 ? parseFloat(apps[0].value) : discount / cart.items_subtotal_price * 100;
    if (!isFinite(pct) || pct <= 0) return '';
    pct = Math.round(pct * 10) / 10;
    return String(pct).replace('.', ',');
  }

  function mapCart(cart, stock) {
    stock = stock || {};
    /* Produktlink in der Sprache des Shops, in dem das Angebot entsteht (cfg.root = '/' bzw. '/en/') */
    var base = location.origin + String(cfg.root || '/').replace(/\/$/, '') + '/products/';
    return cart.items.map(function (it) {
      var st = stock[it.key] || null;
      var hasVariant = it.variant_title && it.variant_title !== 'Default Title';
      return {
        variantId: it.variant_id,
        title: it.product_title,
        variant: hasVariant ? it.variant_title : '',
        sku: it.sku || '',
        qty: it.quantity,
        unit: it.final_price,
        line: it.final_line_price,
        discounted: it.original_line_price > it.final_line_price,
        stock: st ? st.text : '',
        stockColor: st ? st.color : '',
        url: it.handle ? base + it.handle + (hasVariant ? '?variant=' + it.variant_id : '') : ''
      };
    });
  }

  /* Lead an info@ ueber das native Kontaktformular (snippets/tsi-quote-dialog.liquid, #tsi-quote-lead).
     Ablauf: Shopify.captcha.protect verdrahtet hCaptcha, requestSubmit loest Shopifys Captcha-Handler aus (Token).
     Das eigentliche Absenden fangen wir ab (submit-Ereignis bzw. form.submit()) und schicken das Formular per fetch,
     damit Shopifys Antwort lesbar ist. Ergebnis: { ok: true } angenommen, { ok: false, challenge: url } Pruefung
     noetig, { ok: false, reason } Fehler, { ok: null } unbekannt (Absenden lief doch nativ ins versteckte iframe). */
  function sendLead(data) {
    var lf = document.getElementById('tsi-quote-lead');
    if (!lf) {
      var tpl = document.getElementById('tsi-quote-lead-tpl');
      if (!tpl) return Promise.resolve({ ok: false, reason: 'no form' });
      document.body.appendChild(tpl.content.cloneNode(true));
      lf = document.getElementById('tsi-quote-lead');
    }
    if (!lf) return Promise.resolve({ ok: false, reason: 'no form' });
    /* Sicherheitsnetz: laeuft das Absenden doch nativ, bleibt die Seite stehen (Ziel ist ein verstecktes iframe) */
    var frame = document.querySelector('iframe[name="tsi-quote-lead-frame"]');
    if (!frame) {
      frame = document.createElement('iframe');
      frame.name = 'tsi-quote-lead-frame';
      frame.title = 'lead';
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
      document.body.appendChild(frame);
    }
    var lines = [
      'Webshop-Angebot als PDF erstellt (' + lang.toUpperCase() + ')',
      '',
      'Positionen:'
    ];
    if (data.wv) lines.splice(1, 0, 'WARTUNGSEINSATZ laut Wartungsvertrag: 15 % auf alle Positionen (Preise unten bereits rabattiert)' + (data.wv.sn ? ', Anlage SN ' + data.wv.sn : '') + ', Vertriebsmitarbeiter ' + WV_REP + ', erstellt von ' + String(cfg.customer && cfg.customer.email || ''));
    data.items.forEach(function (it) {
      lines.push(it.qty + ' x ' + it.title + (it.variant ? ' (' + it.variant + ')' : '') + (it.sku ? ' [' + it.sku + ']' : '') + ' a ' + money(it.unit) + ' = ' + money(it.line) + (it.stock ? ' | ' + it.stock : ''));
    });
    if (data.rates && data.rates.length) {
      var cheap = data.rates[0];
      lines.push('', 'Summe Positionen netto: ' + money(data.total),
        'Versand nach ' + (data.ratesTo || '-') + ': ' + cheap.name + ' ' + money(cheap.cents),
        'Gesamtsumme netto: ' + money(data.total + cheap.cents));
      if (data.rates.length > 1) lines.push('Alternativ: ' + data.rates.slice(1).map(function (r) { return r.name + ' ' + money(r.cents); }).join(', '));
    } else {
      lines.push('', 'Gesamtsumme netto: ' + money(data.total) + ' (ohne Versand, keine UPS-Rate verfuegbar)');
    }
    lines.push('', 'Bestelllink fuer den Kunden:', data.wv ? 'keiner (Wartungsvertragspreise, Bestellung nur per E-Mail)' : orderLinkFull(data));
    lines.push('', 'PDF erneut erzeugen (identisch):', pdfLink(data));
    function setVal(name, v) { var el = lf.elements[name]; if (el) el.value = v; }
    setVal('contact[email]', data.customer.email);
    setVal('contact[name]', data.customer.name);
    setVal('contact[Firma]', data.customer.company);
    setVal('contact[Angebotsnummer]', data.number);
    setVal('contact[Rechnungsadresse]', addrLine(data.customer.billing) || '-');
    setVal('contact[Lieferadresse]', data.customer.shipping ? addrLine(data.customer.shipping) : 'wie Rechnungsadresse');
    setVal('contact[USt-IdNr]', data.customer.vat || '-');
    setVal('contact[Referenz]', data.customer.reference || '-');
    setVal('contact[body]', lines.join('\n'));
    lf.target = 'tsi-quote-lead-frame';

    return new Promise(function (resolve) {
      var settled = false, sent = false;
      var proto = window.HTMLFormElement.prototype;
      var nativeSubmit = proto.submit;
      function cleanup() {
        proto.submit = nativeSubmit;
        window.removeEventListener('submit', onSubmit);
        frame.onload = null;
      }
      function finish(res, how) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        cleanup();
        log('lead', how, JSON.stringify(res));
        resolve(res);
      }
      var timer = setTimeout(function () { finish({ ok: false, reason: 'timeout' }, 'timeout'); }, 25000);

      function post() {
        if (sent) return;
        sent = true;
        var tok = lf.querySelector('[name="h-captcha-response"]');
        log('post, token', !!(tok && tok.value));
        var body = new URLSearchParams();
        new FormData(lf).forEach(function (v, k) { body.append(k, v); });
        fetch(lf.getAttribute('action') || (cfg.root + 'contact'), {
          method: 'POST', body: body, credentials: 'same-origin', redirect: 'follow'
        }).then(function (r) {
          var u = r.url || '';
          if (/\/challenge/.test(u)) finish({ ok: false, challenge: u }, 'challenge');
          else if (r.ok && /contact_posted=true/.test(u)) finish({ ok: true }, 'posted');
          else finish({ ok: false, reason: r.status + ' ' + u }, 'rejected');
        }).catch(function (err) { finish({ ok: false, reason: String(err) }, 'fetch error'); });
      }
      /* Shopify ruft nach dem Token form.submit() auf: abfangen */
      proto.submit = function () {
        if (this === lf) { post(); return; }
        return nativeSubmit.apply(this, arguments);
      };
      /* Laesst Shopify das submit-Ereignis durch (Token schon da), laeuft dieser Listener als letzter (window, Bubble) */
      function onSubmit(e) {
        if (e.target !== lf || e.defaultPrevented) return;
        e.preventDefault();
        post();
      }
      window.addEventListener('submit', onSubmit);
      /* Falls Shopify das Absenden an uns vorbei nativ ausfuehrt: Ergebnis unbekannt */
      frame.onload = function () { if (!sent) finish({ ok: null, reason: 'native' }, 'iframe'); };

      function go() {
        if (typeof lf.requestSubmit === 'function') {
          lf.requestSubmit();
        } else {
          var b = document.createElement('button');
          b.type = 'submit'; b.hidden = true;
          lf.appendChild(b); b.click(); lf.removeChild(b);
        }
      }
      demote();
      try {
        if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
          log('captcha protect');
          window.Shopify.captcha.protect(lf, go);
        } else { log('kein Shopify.captcha'); go(); }
      } catch (err) { log('captcha error', err); go(); }
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!form.reportValidity()) return;
    var shipOn = !!(shipToggle && shipToggle.checked);
    var customer = {
      company: val('company'), name: val('name'), email: val('email'), reference: val('reference'),
      billing: { street: val('b_street'), zip: val('b_zip'), city: val('b_city'), country: val('b_country'), countryName: countryName('b_country') },
      shipping: shipOn ? { company: val('s_company'), name: val('s_name'), street: val('s_street'), street2: val('s_street2'),
        zip: val('s_zip'), city: val('s_city'), country: val('s_country'), countryName: countryName('s_country') } : null,
      vat: val('vat').toUpperCase().replace(/\s+/g, '')
    };
    try {
      var keep = { ship_diff: shipOn };
      FIELDS.forEach(function (k) { var el = form.elements[k]; if (el) keep[k] = String(el.value || '').trim(); });
      localStorage.setItem('tsi-quote-contact', JSON.stringify(keep));
    } catch (err) {}
    showError(''); setBusy(true);

    var dest = customer.shipping || customer.billing;
    Promise.all([
      fetch(cfg.root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }),
      fetchStock(),
      fetchRates(dest, customer)
    ]).then(function (res) {
      var cart = res[0];
      if (!cart.items || !cart.items.length) throw new Error('empty');
      var items = mapCart(cart, res[1]);
      var number = quoteNumber();
      var now = new Date();
      var valid = new Date(now.getTime() + cfg.validDays * 864e5);
      if (cfg.promoEnd && items.some(function (i) { return i.discounted; })) {
        var pe = new Date(cfg.promoEnd + 'T23:59:59');
        if (pe >= now && pe < valid) valid = pe;
      }
      var orderUrl = location.origin + '/cart/' + items.map(function (i) { return i.variantId + ':' + i.qty; }).join(',') +
        '?attributes%5BAngebotsnummer%5D=' + encodeURIComponent(number);
      var data = {
        lang: lang, number: number, date: now, validUntil: valid, customer: customer, items: items,
        subtotal: cart.items_subtotal_price, discount: Math.max(0, cart.items_subtotal_price - cart.total_price),
        total: cart.total_price, orderUrl: orderUrl
      };
      data.discountPct = discountPct(cart, data.discount);
      if (form.elements.tsi_wv && form.elements.tsi_wv.checked) applyWv(data, form.elements.tsi_wv_sn ? form.elements.tsi_wv_sn.value : '');
      data.rates = res[2] || null;
      data.ratesTo = dest && dest.countryName || '';

      return sendLead(data).then(function (lead) {
        if (lead.challenge) {
          savePending(data);
          showVerify(lead.challenge);
          return;
        }
        if (lead.ok !== true) throw new Error('lead');
        return renderPdf(data).then(function () { showDone(number); setCheckout(data); });
      });
    }).catch(function (err) {
      var msg = err && err.message === 'empty' ? T.err_empty : fill(T.err_pdf, { email: cfg.shop.email });
      showError(msg);
      if (window.console) console.error('[tsi-quote]', err);
    }).then(function () { setBusy(false); });
  });

  /* PDF aus dem Link in der Lead-Mail neu erzeugen: .../#tsi-quote=... */
  (function regenerateFromHash() {
    var m = location.hash.match(/^#tsi-quote=([A-Za-z0-9_-]+)$/);
    if (!m) return;
    var p;
    try { p = unpackPayload(JSON.parse(b64urlDecode(m[1]))); } catch (err) { log('link ungueltig', err); return; }
    try { history.replaceState(null, '', location.pathname + location.search); } catch (err) {}
    showDone(p.number);
    $('[data-quote-checkout]').hidden = true;
    openModal();
    renderPdf(p).catch(function (err) { log('pdf error', err); });
  })();

  /* Rueckkehr nach der Sicherheitspruefung: Shopify leitet mit ?contact_posted=true zurueck. Liegt ein
     zwischengespeichertes Angebot vor, ist es jetzt bei uns eingegangen: Abschluss zeigen, PDF erzeugen. */
  (function resumeAfterVerify() {
    if (!/[?&]contact_posted=true/.test(location.search)) return;
    var pend = takePending();
    if (!pend) return;
    var p;
    try { p = unpackPayload(pend.k); } catch (err) { log('pending ungueltig', err); return; }
    try {
      var qs = location.search.replace(/([?&])contact_posted=true&?/, '$1').replace(/[?&]$/, '');
      history.replaceState(null, '', location.pathname + qs);
    } catch (err) {}
    var TL = TX[p.lang] || T;
    log('resume', p.number);
    showDone(p.number, TL, TL.busy_pdf);
    openModal();
    renderPdf(p).then(function () { showDone(p.number, TL); setCheckout(p); }).catch(function (err) { log('pdf error', err); });
  })();

  $('[data-quote-again]').addEventListener('click', function () {
    if (lastPdf) lastPdf.doc.save(lastPdf.name);
  });
})();
